module.exports = __webpack_public_path__ + "static/media/od-1.7e854364.jpg";